// src/Component/AutoCalculateFields.jsx
import { useEffect } from "react";
import { useFormikContext } from "formik";

export default function AutoCalculateFields() {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    const base = parseFloat(values.tarif_base) || 0;
    const poidsSup = parseFloat(values.poids_supplement) || 0;
    const tempsSup = parseFloat(values.temps_supplement) || 0;
    const suppLiv = parseFloat(values.livraison_supplement) || 0;

    const livraisonHT = base + poidsSup + tempsSup + suppLiv;
    const livraisonHTValue = parseFloat(livraisonHT.toFixed(2));
    console.log("🔢 AutoCalculateFields - Calcul:", {
      base, poidsSup, tempsSup, suppLiv,
      livraisonHT,
      livraisonHTValue,
      isNaN: isNaN(livraisonHTValue)
    });

    // S'assurer que la valeur n'est jamais NaN ou null
    const finalLivraisonHT = isNaN(livraisonHTValue) ? 0 : livraisonHTValue;
    console.log("✅ Définition livraisonHT:", finalLivraisonHT);
    setFieldValue("livraisonHT", finalLivraisonHT);
    setFieldValue("tarif_ht", finalLivraisonHT);

    const tva = parseFloat(values.TVA) || 0;
    const ttc = livraisonHT * (1 + tva / 100);
    const ttcValue = parseFloat(ttc.toFixed(2));
    const finalTtc = isNaN(ttcValue) ? 0 : ttcValue;
    setFieldValue("TTC", finalTtc);
    // tarif_ttc doit toujours refléter TTC : sinon il reste figé (valeur périmée)
    // et désynchronise la facture PDF (basée sur TTC) du montant Stripe (basé sur tarif_ttc).
    setFieldValue("tarif_ttc", finalTtc);
    console.log("✅ Fin AutoCalculateFields - livraisonHT devrait être:", finalLivraisonHT);
  }, [
    values.tarif_base,
    values.poids_supplement,
    values.temps_supplement,
    values.livraison_supplement,
    values.TVA,
    setFieldValue
  ]);

  return null;
}
